import { apiPost } from '../lib/api-utils';

export interface SubscriptionTransaction {
  id: number;
  user_id: number;
  transaction_id: string;
  package_id: number;
  trial_start_date: string | null;
  trial_ends_date: string | null;
  no_of_trial_days_offered: number;
  time_zone: string;
  extended_trial: string | null;
  subscription_availed_date: string;
  subscription_end_date: string;
  subscription_type: string;
  amount: number;
  module_id: string;
  max_no_of_users: number;
  additional_employee_pack: number;
  total_employee_allowed: number;
  renewal_date: string;
  is_active: number;
  status: 'active' | 'expired' | 'cancelled';
  created_at: string;
  updated_at: string;
  app_package_id: string | null;
  is_initial_gift_plan: string;
  is_notification_send: boolean;
  transaction_type: string;
  company_id: string;
  company_name: string;
  package_type: string;
  package_name: string;
  package_duration: number;
  package_duration_type: string;
  access_module_limitation: Record<string, string>;
  pending_access_module: Record<string, string>;
  access_module_object: Record<string, string>;
  owner_company_details: {
    total_employee_allowed?: string;
    company?: Array<{
      company_id: string;
      company_name: string;
      total_employee: string;
    }>;
    total_employee_created?: string;
  };
  // Role might be included in API response
  role?: string;
  user_role?: string;
  [key: string]: unknown; // Allow additional fields from API
}

export type GetSubscriptionTransactionRequest = Record<string, never>;

export interface GetSubscriptionTransactionResponse {
  code: number;
  status: string;
  message: string;
  data: SubscriptionTransaction[];
}

export const getSubscriptionTransaction = async (
  request: GetSubscriptionTransactionRequest = {}
): Promise<GetSubscriptionTransactionResponse> => {
  // A subscription-status check must never trigger the global auto-logout on a
  // 401 -- doing so clears the query cache and refetch-loops pages like /start.
  return apiPost<GetSubscriptionTransactionResponse>(
    'get-subscription-transaction',
    request,
    { skipAuthLogout: true },
  );
};

